import {
  Tooltip as AriaTooltip,
  TooltipTrigger,
  OverlayArrow,
  type TooltipProps as AriaTooltipProps,
} from 'react-aria-components'
import { cn } from '@/lib/utils'

export interface TooltipProps extends AriaTooltipProps {
  children: React.ReactNode
}

export function Tooltip({ children, className, ...props }: TooltipProps) {
  return (
    <AriaTooltip
      className={cn(
        'px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg dark:bg-gray-700',
        'entering:animate-in entering:fade-in-0 entering:zoom-in-95',
        'exiting:animate-out exiting:fade-out-0 exiting:zoom-out-95',
        className
      )}
      {...props}
    >
      <OverlayArrow>
        {({ placement }) => (
          <svg
            width={12}
            height={6}
            viewBox="0 0 12 6"
            className={cn(
              'fill-gray-900 dark:fill-gray-700',
              placement === 'bottom' && 'rotate-180',
              placement === 'left' && '-rotate-90',
              placement === 'right' && 'rotate-90'
            )}
          >
            <path d="M0 6L6 0l6 6H0z" />
          </svg>
        )}
      </OverlayArrow>
      {children}
    </AriaTooltip>
  )
}

export { TooltipTrigger }

export default Tooltip
